<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Tarih</label>
            <v-validator :errors="errors" parameter="Date" :watch="form.Date">
                 <v-date-picker v-model="form.Date" type="datetime" :forBack="true" class="w-100" />
            </v-validator>
        </div>

        <div class="col-md-6 mb-1">
            <label class="form-label">Araç Plaka</label>
            <v-validator :errors="errors" parameter="VehiclePlateId" :watch="form.VehiclePlateId">
                <v-select-list 
                    v-model="form.VehiclePlateId" 
                    :options="vehiclePlates" 
                    label="PlateValue" 
                    :reduce="(option) => option.Id" 
                    placeholder="Seçiniz..."
                />
            </v-validator>
        </div>

        <div class="col-md-6 mb-1">
            <label class="form-label">Personel</label>
             <v-validator :errors="errors" parameter="EmployeeId" :watch="form.EmployeeId">
                <v-select-list 
                    v-model="form.EmployeeId" 
                    :options="employees" 
                    label="FullName" 
                    :reduce="(option) => option.Id" 
                    placeholder="Seçiniz..."
                    @input="onEmployeeChange"
                />
            </v-validator>
        </div>

        <div class="col-md-6 mb-1">
             <label class="form-label">Şube (Otomatik)</label>
             <input type="text" class="form-control" :value="form.EmployeeCurrentBranchName || ''" disabled />
        </div>

        <div class="col-md-6 mb-1">
             <label class="form-label">Görev Yeri (Otomatik)</label>
             <input type="text" class="form-control" :value="form.VehicleInventoryGarageName || ''" disabled />
        </div>

        <div class="col-md-6 mb-1">
             <label class="form-label">Yakıt Tipi</label>
             <v-validator :errors="errors" parameter="FuelTypeId" :watch="form.FuelTypeId">
                <v-select-list
                    v-model="form.FuelTypeId"
                    :options="fuelTypes"
                    label="VisibleName"
                    :reduce="(option) => option.Id"
                    placeholder="Seçiniz..."
                />
            </v-validator>
        </div>

        <div class="col-md-6 mb-1">
            <label class="form-label">Miktar (Lt)</label>
            <v-validator :errors="errors" parameter="Quantity" :watch="form.Quantity">
                <input type="number" class="form-control" v-model="form.Quantity" step="0.01" />
            </v-validator>
        </div>

         <div class="col-md-6 mb-1">
            <label class="form-label">Tutar (Vergi Dahil)</label>
             <v-validator :errors="errors" parameter="VDPrice" :watch="form.VDPrice">
                <input type="number" class="form-control" v-model="form.VDPrice" step="0.01" @input="calculatePrices" />
            </v-validator>
        </div>

        <div class="col-md-6 mb-1">
            <label class="form-label">KDV Oranı (%)</label>
             <v-validator :errors="errors" parameter="TaxRate" :watch="form.TaxRate">
                <input type="number" class="form-control" v-model="form.TaxRate" step="1" @input="calculatePrices" />
            </v-validator>
        </div>

        <div class="col-md-6 mb-1">
            <label class="form-label">Vergi Hariç Tutar (Hesaplanan)</label>
            <input type="text" class="form-control" :value="calculatedVHPrice" disabled />
        </div>

        <div class="col-md-6 mb-1">
             <label class="form-label">KDV Tutarı (Hesaplanan)</label>
             <input type="text" class="form-control" :value="calculatedTaxPrice" disabled />
        </div>

        <div class="col-md-6 mb-1">
            <label class="form-label">İstasyon / Firma Adı</label>
             <v-validator :errors="errors" parameter="FuelStationFirmName" :watch="form.FuelStationFirmName">
                 <input type="text" class="form-control" v-model="form.FuelStationFirmName" />
            </v-validator>
        </div>

        <div class="col-md-6 mb-1">
            <label class="form-label">İl</label>
             <v-validator :errors="errors" parameter="ProvinceId" :watch="form.ProvinceId">
                 <v-select-list
                    v-model="form.ProvinceId"
                    :options="provinces"
                    label="Name"
                    :reduce="(option) => option.Id"
                    placeholder="Seçiniz..."
                    clearable
                />
            </v-validator>
        </div>

        <div class="col-md-6 mb-1">
            <label class="form-label">İlçe</label>
             <v-validator :errors="errors" parameter="DistrictId" :watch="form.DistrictId">
                 <v-select-list
                    v-model="form.DistrictId"
                    :options="districts"
                    label="Name"
                    :reduce="(option) => option.Id"
                    placeholder="Önce İl Seçiniz..."
                    :disabled="!form.ProvinceId"
                    clearable
                />
            </v-validator>
        </div>

        <div class="col-12 mb-1">
            <label class="form-label">Adres</label>
             <v-validator :errors="errors" parameter="Address" :watch="form.Address">
                <textarea class="form-control" v-model="form.Address" rows="2"></textarea>
            </v-validator>
        </div>

         <div class="col-12 mb-1">
             <label class="form-label">Açıklama</label>
             <v-validator :errors="errors" parameter="Description" :watch="form.Description">
                <textarea class="form-control" v-model="form.Description" rows="2"></textarea>
            </v-validator>
        </div>

    </div>
</template>

<script>
import systemDataApi from "@/api/system-data";
import EmployeeOperationsApi from "@/api/employee-operations";
import CompanyApi from "@/api/company";
import fuelStorageApi from "@/api/fuel-storage";

export default {
    components: {
    },
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
        errors: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            form: this.value,
            employees: [],
            vehiclePlates: [],
            fuelTypes: [],
            districts: [],
            provinces: [],
            countries: [],
            branches: [],
            garages: [], // Assuming garages can be fetched or are related to employee
            calculatedVHPrice: 0,
            calculatedTaxPrice: 0
        }
    },
    watch: {
        value: {
            handler(val) {
                this.form = val;
                this.calculatePrices();
            },
            deep: true
        },
        "form.ProvinceId": {
            handler(val, oldVal) {
                if (val) {
                    if (val !== oldVal) {
                        this.loadDistricts(val);
                        // Clear district only if it's a manual change by user (oldVal exists and is different)
                        // On initial load (immediate: true), oldVal is undefined, so we preserve form.DistrictId
                        if (oldVal && oldVal !== val) {
                            this.form.DistrictId = null;
                        }
                    }
                } else {
                    this.districts = [];
                    this.form.DistrictId = null;
                }
            },
            immediate: true
        },
        form: {
            handler(val) {
                this.$emit('input', val);
            },
            deep: true
        }
    },
    mounted() {
        this.loadEmployees();
        this.loadVehiclePlates();
        this.loadFuelTypes();
        this.loadProvinces();
        this.loadBranches();
        if(!this.form.Date) {
             this.form.Date = new Date();
        }
        if(this.form.TaxRate === undefined || this.form.TaxRate === null) {
            this.form.TaxRate = 20;
        }
        this.calculatePrices();
    },
    methods: {
        calculatePrices() {
            const vdPrice = parseFloat(this.form.VDPrice) || 0;
            const taxRate = parseFloat(this.form.TaxRate) || 0;
            const vhPrice = vdPrice / (1 + (taxRate / 100));
            const taxPrice = vdPrice - vhPrice;
            
            this.calculatedVHPrice = vhPrice.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });
            this.calculatedTaxPrice = taxPrice.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });
        },
        async loadEmployees() {
            try {
                const response = await EmployeeOperationsApi.Employee.List(false);
                 if (response.data.Success) {
                     this.employees = response.data.Data || [];
                 }
            } catch (error) {
                console.error("Employess loading error", error);
            }
        },
        async loadVehiclePlates() {
            try {
               const response = await systemDataApi.VehiclePlate();
               if (response.data.Success) {
                   this.vehiclePlates = response.data.Data || [];
               }
            } catch (error) {
                console.error("Vehicle plates loading error", error);
            }
        },
         async loadFuelTypes() {
            try {
                const response = await systemDataApi.FuelType(true);
                if (response.data.Success) {
                    this.fuelTypes = response.data.Data || [];
                }
            } catch (error) {
                console.error("Error loading fuel types:", error);
            }
        },
        async loadProvinces() {
            try {
                const countryRes = await systemDataApi.Country();
                if (countryRes.data.Success) {
                    const countries = countryRes.data.Data || [];
                    // Look for Turkey case-insensitively and by IsDefault
                    const turkey = countries.find(c => 
                        c.IsDefault || 
                        (c.Name && (
                            c.Name.toUpperCase() === 'TÜRKİYE' || 
                            c.Name.toUpperCase() === 'TURKIYE' || 
                            c.Name.toUpperCase() === 'TURKEY'
                        ))
                    );
                    
                    if (turkey) {
                        const response = await systemDataApi.ProvinceByCountry(turkey.Id);
                        if (response.data.Success) {
                            this.provinces = response.data.Data || [];
                            return;
                        }
                    }
                }
                // Fallback to all provinces if filter fails
                const response = await systemDataApi.Province();
                if (response.data.Success) {
                    this.provinces = response.data.Data || [];
                }
            } catch (error) {
                console.error("Error loading provinces:", error);
            }
        },
        async loadDistricts(provinceId) {
            if (!provinceId) return;
            try {
                const response = await systemDataApi.District(provinceId);
                if (response.data.Success) {
                    this.districts = response.data.Data || [];
                }
            } catch (error) {
                console.error("Error loading districts:", error);
            }
        },
        async loadBranches() {
             try {
                const response = await CompanyApi.Branch.ListByCode("O");
                if (response.data.Success) {
                    this.branches = response.data.Data || [];
                }
            } catch (error) {
                console.error("Error loading branches:", error);
            }
        },
        async onEmployeeChange(employeeId) {
            if (!employeeId) {
                this.$set(this.form, "EmployeeCurrentBranchId", null);
                this.$set(this.form, "EmployeeCurrentBranchName", null);
                this.$set(this.form, "VehicleInventoryGarageId", null);
                this.$set(this.form, "VehicleInventoryGarageName", null);
                return;
            }
            try {
                // Aktif şube (EmployeeBranch tablosu) ve aktif görev yeri (EmployeeGarage tablosu) otomatik getir.
                const response = await fuelStorageApi.BuyingFuel.GetEmployeeCurrentAssignment(employeeId);
                if (response.data.Success && response.data.Data) {
                    const data = response.data.Data;
                    this.$set(this.form, "EmployeeCurrentBranchId", data.EmployeeCurrentBranchId || null);
                    this.$set(this.form, "EmployeeCurrentBranchName", data.EmployeeCurrentBranchName || null);
                    this.$set(this.form, "VehicleInventoryGarageId", data.VehicleInventoryGarageId || null);
                    this.$set(this.form, "VehicleInventoryGarageName", data.VehicleInventoryGarageName || null);
                }
            } catch (error) {
                console.error("Error fetching employee assignment:", error);
            }
        }

    }
}
</script>
